import { Box, Skeleton } from '@mui/material';
import { FormRow } from 'components/common/FormWrapper/styles';

const Input = () => <Skeleton
  height={65}
/>;
const Button = () => <Skeleton
  height={65} width={225}
/>;
const SkeletonLoader = () => {
  return (
    <Box
      sx={{ margin: '10px' }}>
      <FormRow
        marginTop='46px' gridGap='16px' cols='2'>
        <Input />
        <Input />
      </FormRow>
      <FormRow
        marginTop='46px' gridGap='16px' cols='2'>
        <Input />
        <Input />
      </FormRow>
      <FormRow
        marginTop='46px' gridGap='16px' cols='2'>
        <Input />
        <Input />
      </FormRow>
      <FormRow
        marginTop='42px' gridGap='16px' cols='2'>
        <Button />
      </FormRow>
    </Box>
  );
};

export default SkeletonLoader;
